<template>
  <v-container
    text-center
    justify-center>
    <v-layout
      row
      wrap>
      <v-flex xs12>
        <h1>サイラボ 自分カレンダー</h1>
        自身の生年月日で決まる宿命の時計に従って行動してみませんか？<br>
        自分の宿命に沿った開運の可能性を暦やスケジュール管理で発見できるサポートを<br>
        算命学の視点で行うカレンダーアプリです。<br>
      </v-flex>

      <v-flex
        xs12
        mt-5>
        <div
          v-if="!$store.state.login_user"
          class="my-2">
          <p>
            まずはユーザ登録で生年月日を設定し、自分の宿命を知りましょう。
          </p>
          <div class="my-4">
            <v-btn
              class="mx-2 my-2"
              color="info"
              :to="{ name: 'register' }">
              メールアドレスで登録
            </v-btn>
            <v-btn
              class="mx-2 my-2"
              color="red white--text"
              style="text-transform: none"
              @click="clickRegisterGoogle">
              Googleアカウントで登録
            </v-btn>
            <v-btn
              class="mx-2 my-2"
              color="indigo darken-1 white--text"
              style="text-transform: none"
              @click="clickRegisterFacebook">
              Facebookアカウントで登録
            </v-btn>
          </div>
        </div>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
// @ is an alias to /src
import { mapActions } from 'vuex'

export default {
  methods: {
    clickRegisterGoogle() {
      this.loginGoogle()
    },
    clickRegisterFacebook() {
      this.loginFacebook()
    },
    ...mapActions(['loginGoogle', 'loginFacebook']),
  },
}
</script>
